import useAuthenticated from '../hooks/useAuthentication';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

function useAuthenticationToken() {
  const { instance: msal, account } = useAuthenticated();

  function callWithToken(callback) {
    return msal
      .acquireTokenSilent({ account: account() })
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch(async (error) => {
        console.warn(error);

        if (error instanceof InteractionRequiredAuthError) {
          return msal.acquireTokenRedirect({ account: account() });
        }
      });
  }

  return {
    callWithToken
  };
}

export default useAuthenticationToken;
